import { ArrowForward, DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { InvoiceFormField } from "./InvoiceFormField";

export const InvoiceProcess = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <ArrowForward style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Process")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <InvoiceFormField label={t("InvoiceProcess")} type="disabled" code="InvoiceProcess" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("VesselCode")} type="disabled" code="VesselCode" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("Voyage")} type="disabled" code="Voyage" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("LineCode")} type="disabled" code="LineCode" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("ServiceCode")} type="disabled" code="ServiceCode" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("ServiceBound")} type="disabled" code="ServiceBound" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("ProcessKey")} type="disabled" code="ProcessKey" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}